module.exports = __webpack_public_path__ + "assets/a46050a6f29f455b107d39c4a6cffad4.svg";